// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.flex > .v-subheader {\n  height: auto;\n}\n.v-data-table table tbody tr.v-data-table__expanded__content {\n  box-shadow: none;\n  -webkit-box-shadow: none;\n}\n", ""]);
// Exports
module.exports = exports;
